export default `subscription updatedTodo {
  updatedTodo {
	todoId
	body
	createdOn
	createdBy
  }
}`;
